import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box } from "@mui/material";
import "swiper/swiper-bundle.css";
import "./syle.css";
import SubAlignmentKrCart from "../../../CompanyTeams/LComponents/SubAlignmentKrCart/SubAlignmentKrCart";

interface Props {
  keyresultData: any;
  setShowToastMessage: (message: any) => void;
  setKrId: any;
  meetingId: any;
  personPicture: string;
}

const CoopSlider: React.FC<Props> = ({
  keyresultData,
  setShowToastMessage,
  setKrId,
  meetingId,
  personPicture,
}) => {

  return (
<Box
  width={ '100%'} // در موبایل عرض به 100% تغییر می‌کند
  mx="auto"
  display="flex"
>     
      <Swiper
        style={{ textAlign: "center", fontSize: "2rem" }}
        spaceBetween={30}
        slidesPerView={3}
        navigation
        onRealIndexChange={() => {}}
        onSwiper={(swiper) => {}}
      >
        {keyresultData &&
          keyresultData.map((o: any, i: number) => {
            return (
              <SwiperSlide key={i}>
               <Box sx={{ width: "100%" }}>
                    <Box key={i} px={1}>
                    <SubAlignmentKrCart
                        setKrId={setKrId} 
                        meetingId={meetingId}
                        setShowToastMessage={setShowToastMessage}
                        personPicture={personPicture}
                        item={o}
                />
                    </Box>
            </Box>
              </SwiperSlide>
              
            );
          })}
      </Swiper>
    </Box>
  );
};

export default CoopSlider;
